import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExpandLess = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9 6.22119L4.5 10.7212L5.5575 11.7787L9 8.34369L12.4425 11.7787L13.5 10.7212L9 6.22119Z",
		fill: "currentColor"
	})
});
export default SvgExpandLess;
